import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ParseService } from '../../../shared/common/parse/parse.service';
import { WorkElement } from '../../../shared/common/interface';
import { BreakElement } from '../../../shared/common/interface';
import { Router, ActivatedRoute } from '@angular/router';
import { QueryInterface } from '../../../shared/common/parse/query-interface';
import { DatePipe } from '@angular/common';
import { SessionHandler } from 'app/shared/common/parse/session-handler';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { fuseAnimations } from '@fuse/animations';
import { Lightbox } from 'ngx-lightbox';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { SocketService } from 'app/shared/common/helper/socket.service';
import { DateServiceService } from 'app/shared/common/helper/dateservice';

@Component({
    selector: 'app-timesheet-view',
    templateUrl: './timesheet-view.component.html',
    styleUrls: ['./timesheet-view.component.scss'],
    animations: fuseAnimations
})

export class TimesheetViewComponent implements OnInit {

    last15days = [];
    selectedDate: Date;
    selectbydate = new Date();
    displayedColumns: string[] = ['WorkProject', 'WorkTimeIn', 'WorkTimeOut', 'WorkHours'];
    displayedColumnsnew: string[] = ['BreakTimeIn', 'BreakTimeOut', 'BreakHours', 'Comments', 'Reasons'];
    dataSource1 = new MatTableDataSource(workData);
    dataSource2 = new MatTableDataSource(breakData);
    startingTime: any;
    graceStartTime: any;
    tenantId = '';
    workHoursInfo: any;
    checkInWorkHours: string = '00:00:00';
    breakHoursInfo: any = [];
    checkOutWorkHours: string = '00:00:00';
    checkInTime: any;
    checkOutTime: any;
    isCheckIn: boolean = false;
    applyFilter(filterValue: string) { this.dataSource2.filter = filterValue; this.dataSource1.filter = filterValue; }
    sample = [];
    from: string;
    index: any[];
    localWorkAttendance: any[];
    localBreakAttendance: any[];
    firstTimeofday: any;
    lastTimeofday: any;
    workData: [];
    norecord: boolean;
    breakData: [];
    collection = [];
    emp_id: string;
    selectedUserProfileId: '';
    noTable = true;
    noData = false;
    objectId = '';
    tabIndex = new FormControl(0);
    profileId = '';
    resourceSelect: string = '';
    resourcesList: string[] = [];
    empRole = '';
    myControl = new FormControl();
    options: string[] = ['dsf', 'dsfa'];
    currentUser: any;
    startTime: any;
    profileValue: any;
    profileUserId: any;
    inTime: any;
    outTime: any;
    isClosed: boolean;
    reportingList = [];
    reportingToDD = [];
    reportingToOptions: SelectItem[];
    filteredOptions: Observable<string[]>;
    currentuser = this.parseService.instance.User.current();
    firstname: String;
    lastname: String;
    event: string;
    imageDetails: any[];
    images = [];
    screenShotImage = [];
    firstName = this.parseService.instance.User.current().get('firstName');
    lastName = this.parseService.instance.User.current().get('lastName');
    selectedTabIndex = 0;
    @Input() userId: any;


    constructor(
        private parseService: ParseService,
        private router: Router,
        private route: ActivatedRoute,
        private queryInterface: QueryInterface,
        private sessionHandler: SessionHandler,
        private storageConfiguration: StorageConfiguration,
        private _lightbox: Lightbox,
        private getReportingToService: GetReportingToService,
        private _socket: SocketService,
        private dateService: DateServiceService
    ) {


    }

    /*
    ** ==========================================================
    ** On init
    ** ==========================================================
    */
    ngOnInit() {
        this.profileId = this.parseService.instance.User.current().get('profile').id;
        this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
        this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
        this.getReportingTo();

        this.route.params.subscribe(params => {
            this.selectedUserProfileId = params['id'];
            this.getScreenShotsByChoosingDate();
        });
        this.route.params.subscribe(params => {
            this.objectId = params['id'];
            this.event = params['event'];
        });
        if (this.objectId) {
            var user = new this.parseService.instance.Object('Profile');
            user.id = this.objectId;
            this.currentuser = user;
            user.fetch().then(
                res => {
                    this.firstname = res.get('firstName');
                    this.lastname = res.get('lastName');
                });
            this.getProfileToUser();
        }
        if (this.userId) {
            var user = new this.parseService.instance.Object('Profile');
            user.id = this.userId;
            this.currentuser = user;
            this.objectId = this.userId;
            user.fetch().then(
                res => {
                    this.firstname = res.get('firstName');
                    this.lastname = res.get('lastName');
                });
            this.getProfileToUser();
            this.selectedUserProfileId = this.userId;
            this.getScreenShotsByChoosingDate();
        }
        this.getCheckInCheckOutInfo(new Date());
    }

    getProfileToUser() {
        this.queryInterface.executeQuery(this.parseService, 'User', [
            { condition: 'equalTo', field: 'profile', value: { __type: 'Pointer', className: 'Profile', objectId: this.objectId } },
            { condition: 'include', value: 'profile' },
        ]).then(results => {
            if (results.length > 0) {
                let result = results[0];
                this.objectId = result.id;
                var user = new this.parseService.instance.Object('User');
                user.id = result.id;
                this.currentUser = user;
            }
            this.last15DaysTimesheet(0);
            this.getEmployee('');
            this.Last15Days();
        });
    }

    /*
    ** ======================================================================
    ** Getting Employees Timesheet/Screenshot Details By Choosing Resource
    ** ======================================================================
    */
    chooseResource(event) {
        this.objectId = event;
        this.tabIndex.setValue(0);
        this.router.navigate(['timesheet-view', { id: event }]);
        this.getTimesshetData();

        if (this.profileId != event) {
            var queryProfile = new this.parseService.instance.Object('Profile');
            queryProfile.id = event;
            if (this.selectedTabIndex === 0) {
                let sendSocket = {
                    event_type: 'WATCHING_TIMESHEET',
                    event_owner: {
                        id: this.parseService.instance.User.current().get('profile').id,
                        name: this.firstName + ' ' + this.lastName,
                    },
                    event_receiver: {
                        id: event,
                        name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
                    },
                    message: this.firstName + ' ' + this.lastName + ' watched your timesheet',
                    event_created_Date: new Date(),
                    initiated_source: 'web',
                    pageType: 'Timesheet',
                    isNotified: true
                }
                this.sendSocketData(sendSocket);
            }
            if (this.selectedTabIndex === 1) {
                let sendSocket = {
                    event_type: 'WATCHING_SCREENSHOT',
                    event_owner: {
                        id: this.parseService.instance.User.current().get('profile').id,
                        name: this.firstName + ' ' + this.lastName,
                    },
                    event_receiver: {
                        id: event,
                        name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
                    },
                    message: this.firstName + ' ' + this.lastName + ' watched your screenshots',
                    event_created_Date: new Date(),
                    initiated_source: 'web',
                    pageType: 'Screenshots',
                    isNotified: true
                }
                this.sendSocketData(sendSocket);
            }
        }
    }

    tabChange(event) {
        this.selectedTabIndex = event.index;
        if (this.profileId != this.selectedUserProfileId) {
            if (event.index === 0) {
                var queryProfile = new this.parseService.instance.Object('Profile');
                queryProfile.id = this.selectedUserProfileId;
                let sendSocket = {
                    event_type: 'WATCHING_TIMESHEET',
                    event_owner: {
                        id: this.parseService.instance.User.current().get('profile').id,
                        name: this.firstName + ' ' + this.lastName,
                    },
                    event_receiver: {
                        id: this.selectedUserProfileId,
                        name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
                    },
                    message: this.firstName + ' ' + this.lastName + ' watched your timesheet',
                    event_created_Date: new Date(),
                    initiated_source: 'web',
                    pageType: 'Timesheet',
                    isNotified: true
                }
                this.sendSocketData(sendSocket);
            }
            if (event.index === 1) {
                var queryProfile = new this.parseService.instance.Object('Profile');
                queryProfile.id = this.selectedUserProfileId;
                let sendSocket = {
                    event_type: 'WATCHING_SCREENSHOT',
                    event_owner: {
                        id: this.parseService.instance.User.current().get('profile').id,
                        name: this.firstName + ' ' + this.lastName,
                    },
                    event_receiver: {
                        id: this.selectedUserProfileId,
                        name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
                    },
                    message: this.firstName + ' ' + this.lastName + ' watched your screenshots',
                    event_created_Date: new Date(),
                    initiated_source: 'web',
                    pageType: 'Screenshots',
                    isNotified: true
                }
                this.sendSocketData(sendSocket);
            }
        }
    }

    async sendSocketData(sendSocket) {
        let queryInstance = this.parseService.instance.Object.extend('DataSettings');
        let query = new this.parseService.instance.Query(queryInstance);
        let queryDataSettingResult = await query.find();

        let pageVisitClass = this.parseService.instance.Object.extend('PageVisit');
        let queryPageVisitClass = new this.parseService.instance.Query(pageVisitClass);
        let dateDifferents = this.dateService.startEndDateByDate(new Date());
        queryPageVisitClass.greaterThan('createdAt', dateDifferents[0]);
        queryPageVisitClass.lessThan('createdAt', dateDifferents[1]);
        queryPageVisitClass.equalTo('pageType', sendSocket.pageType);
        queryPageVisitClass.equalTo('receiverId', { __type: 'Pointer', className: 'Profile', objectId: sendSocket.event_receiver.id });
        queryPageVisitClass.descending('createdAt');
        queryPageVisitClass.equalTo('isNotified', true);
        let isNotified = true;
        let pageVisitResult = await queryPageVisitClass.find();
        if (pageVisitResult.length > 0) {
            let lastCreatedAt = pageVisitResult[0].get('createdAt');
            let currentTimeDifference = Math.ceil(((new Date().getTime()) - (new Date(lastCreatedAt).getTime())) / 1000);
            if (currentTimeDifference < queryDataSettingResult[0].get('notificationThreshold')) {
                isNotified = false;
            }
        }
        sendSocket.isNotified = isNotified;
        if (sendSocket.isNotified == true) {
            this._socket.sendSocketEvent('SOCKET_EMIT_EVENT', sendSocket);
        }
    }

    getTimesshetData() {
        if (this.objectId) {
            this.queryInterface.executeQuery(this.parseService, 'User', [
                { condition: 'equalTo', field: 'profile', value: { __type: 'Pointer', className: 'Profile', objectId: this.objectId } },
                { condition: 'include', value: 'profile' },
            ]).then(results => {
                let result = results[0];
                this.objectId = result.id;
                var user = new this.parseService.instance.Object('User');
                user.id = result.id;
                this.currentUser = user;
                this.last15DaysTimesheet(0);
                this.Last15Days();
                this.getEmployee('');
                var user = new this.parseService.instance.Object('_User');
                user.id = this.currentUser.id;
                this.currentuser = user;
                user.fetch().then(
                    res => {
                        this.firstname = res.get('firstName');
                        this.lastname = res.get('lastName');
                    });
            });
        }
    }

    /*
    ** ==========================================================
    ** Getting Employees Timesheet Details
    ** ==========================================================
    */
    getPreviousDayTimesheet() {
        this.selectedDate = new Date(this.selectbydate);
        this.getTimesheet(this.selectedDate);
        this.getCheckInCheckOutInfo(this.selectedDate);
    }

    Last15Days() {
        var result = [];
        for (var i = 0; i < 15; i++) {
            var d = new Date();
            d.setDate(d.getDate() - i);
            result.push(d);
        }
        this.last15days = result;
    }

    last15DaysTimesheet($event) {
        this.selectedDate = this.last15days[$event];
        this.getTimesheet(this.selectedDate);
        this.getCheckInCheckOutInfo(this.selectedDate);
    }

    getTimesheet(selectbydate) {
        let date = selectbydate != undefined ? selectbydate : new Date();
        let startend = this.startenddates(date);
        let timesheet = this.parseService.instance.Object.extend('UserTimeSheet');
        let query = new this.parseService.instance.Query(timesheet);
        query.equalTo('user', { __type: 'Pointer', className: '_User', objectId: this.currentUser.id });
        query.descending('createdAt');
        query.greaterThan('createdAt', startend[0]);
        query.lessThan('createdAt', startend[1]);
        query.find().then(results => {
            if (results.length == 1) {
                this.noData = false;
                this.noTable = true;
                let attendance = results[0];
                let workTime = attendance.get('workTime');
                let breakTime = attendance.get('breakTime');
                this.inTime = new Date(attendance.get('inTime'));
                this.outTime = attendance.get('outTime');
                this.isClosed = attendance.get('isClosed');
                this.startingTime = attendance.get('agreedStartTime');
                let totalAttendance = attendance.get('totalAttendance');
                this.formatStartTime(date.toISOString());
                this.displayEvent(workTime, breakTime);
                this.firstTimeofday = this.secondsToHms(totalAttendance.worktime);
                this.lastTimeofday = this.secondsToHms(totalAttendance.breaktime);
            } else if (results.length == 0) {
                this.noData = true;
                this.noTable = false;
                this.norecord = true;
                this.dataSource1 = new MatTableDataSource(workData);
                this.dataSource2 = new MatTableDataSource(breakData);
                this.firstTimeofday = 0;
                this.lastTimeofday = 0;
            }
        });
    }

    /*
    ** ==========================================================
    ** Data Binding Function
    ** ==========================================================
    */
    displayEvent(workTime, breakTime) {
        let project = null, inTime = null, outTime = null, actualHours = null, breakHours = null, reasonobj = null,
            elt = null, reasonname = null, reasonComment1 = null, reasonComment2 = null, breakData = [];
        this.dataSource2 = new MatTableDataSource(breakData);
        workData = [];
        this.dataSource1 = new MatTableDataSource(workData);
        for (let i = 0; i < workTime.length; i++) {
            elt = workTime[i];
            inTime = this.time(new Date(elt.inTime));
            outTime = null;
            actualHours = null;
            project = null;
            if (
                elt.outTime != 0 && elt.outTime != null &&
                elt.actualHours != 0 && elt.actualHours != null &&
                elt.project != null
            ) {
                outTime = this.time(new Date(elt.outTime));
                actualHours = this.secondsToHms(Math.ceil(elt.actualHours / 1000));
                project = elt.project.name;
                workData.push({
                    WorkProject: project,
                    WorkTimeIn: inTime,
                    WorkTimeOut: outTime,
                    WorkHours: actualHours
                });
            }
            this.dataSource1 = new MatTableDataSource(workData);
        }
        for (let i = 0; i < breakTime.length; i++) {
            elt = breakTime[i];
            outTime = this.time(new Date(elt.outTime));
            (inTime = null),
                (breakHours = null),
                (reasonobj = null),
                (reasonname = null);
            (reasonComment1 = null);
            (reasonComment2 = null);
            if (elt.inTime != 0 && elt.inTime != null &&
                elt.breakHours != 0 && elt.breakHours != null &&
                elt.reason != null) {
                inTime = this.time(new Date(elt.inTime));
                breakHours = this.secondsToHms(Math.ceil(elt.breakHours / 1000));
                reasonobj = elt.reason;
                reasonname = reasonobj.reason;
                let reason = '';
                if (reasonname == 'Other') {
                    reason = reasonobj.other;
                } else {
                    reasonComment1 = reasonobj.subject == undefined ? '' : reasonobj.subject;
                    reasonComment2 = reasonobj.withWho == undefined ? '' : reasonobj.withWho;
                    reason = (reasonComment1 == '' && reasonComment2 == '') ? '' : reasonComment1.concat(' with ' + reasonComment2);
                }
                breakData.push({
                    BreakTimeIn: outTime,
                    BreakTimeOut: inTime,
                    BreakHours: breakHours,
                    Comments: reasonname,
                    Reasons: reason
                });
            }
            this.dataSource2 = new MatTableDataSource(breakData);
        }
    }

    /*
    ** ==========================================================
    ** Getting Employees Screenshot Details
    ** ==========================================================
    */
    getScreenShotsByChoosingDate() {
        this.selectedDate = new Date(this.selectbydate);
        this.getScreenshotImage(this.selectedDate);
    }

    last15DaysScreenShots($event) {
        this.selectedDate = this.last15days[$event];
        this.getScreenshotImage(this.selectedDate);
    }

    getScreenshotImage(selectbydate) {
        this.imageDetails = [];
        let img = '';
        this.images = [];
        let description = '';
        let queryInstance = this.parseService.instance.Object.extend('UserScreenShots');
        let query = new this.parseService.instance.Query(queryInstance);
        let date = selectbydate != undefined ? selectbydate : new Date();
        let startend = this.startenddates(date);
        query.descending('createdAt');
        query.greaterThan('createdAt', startend[0]);
        query.lessThan('createdAt', startend[1]);
        query.include('profileId');
        query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.selectedUserProfileId });
        query.find().then(results => {
            let images = [];
            results.forEach(element => {
                this.imageDetails = element.get('imageDetails');
                this.imageDetails.forEach(innerElement => {
                    img = innerElement.apiUrl;
                    let recordedTime = (new Date(innerElement.recordedTime));
                    description = 'Screenshot';
                    images.push({
                        src: img,
                        caption: recordedTime,
                        thumb: img
                    });
                });
            });
            this.screenShotImage = images;
        });
    }

    /*
    ** ==========================================================
    **  Get Reporting To Dropdown
    ** ==========================================================
    */
    async getReportingTo() {
        await this.getReportingToService.getReportingTo().then(res => {
            this.reportingToDD = res;
        });
    }

    bindDropDown(array: any[]): any[] {
        const dropDownItem = [];
        array.forEach(a => {
            dropDownItem.push({ label: a.name, value: a.id });
        });
        return dropDownItem;
    }

    /*
    ** ==========================================================
    **  Get Auto Complete Dropdown
    ** ==========================================================
    */
    getEmployee(event) {
        let data = [];
        let queryInstance = this.parseService.instance.Object.extend('Profile');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('isActive', true);
        query.limit(2000);
        query.ascending('firstName');
        query.equalTo('tenantId', this.tenantId)
        if (this.empRole == 'Leader') {
            query.equalTo('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
        }
        else if (event != '' && this.empRole == 'Admin') {
            query.equalTo('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: event.value });
        }
        query.find().then(results => {
            for (let i = 0; i < results.length; i++) {
                var username = results[i].get('firstName') + ' ' + results[i].get('lastName');
                var objectId = results[i].id;
                data.push({ name: username, value: objectId });
                this.resourcesList = data;
            }
            this.getFilteredValue();
        });
    }

    uniqBy(a, key) {
        var index = [];
        return a.filter(function (item) {
            var k = key(item);
            return index.indexOf(k) >= 0 ? false : index.push(k);
        });
    }

    getFilteredValue() {
        if (this.resourcesList.length > 0) {
            this.filteredOptions = this.myControl.valueChanges.pipe(
                startWith(''),
                map(skillSets => this._filter(skillSets))
            );
        }
    }

    private _filter(value: string): any[] {
        let userRole1 = JSON.stringify(this.resourcesList);
        let userRole = JSON.parse(userRole1);
        const filterValue = value.toLowerCase();
        return userRole.filter(option => option.name
            .toString()
            .toLowerCase()
            .includes(filterValue)
        );
    }

    dayafterGraph(d) {
        let day = new Date(d);
        return new Date(day.setDate(day.getDate() + 1));
    }

    daybeforeGraph(d) {
        let day = new Date(d);
        return new Date(day.setDate(day.getDate() - 15));
    }

    startenddatesGraph(day) {
        let startdate = this.daybeforeGraph(new Date(day));
        startdate.setHours(23, 59, 59, 999);
        let enddate = this.dayafterGraph(day);
        enddate.setHours(0, 0, 0, 0);
        return [startdate, enddate];
    }

    /*
    ** ==========================================================
    ** Getting Today's Date
    ** ==========================================================
    */
    getToday(): string {
        return new Date().toISOString().split('T')[0];
    }

    /*
    ** ==========================================================
    ** Time Conversion
    ** ==========================================================
    */
    secondsToHms(d) {
        d = Number(d);
        let h = Math.floor(d / 3600);
        let m = Math.floor((d % 3600) / 60);
        let s = Math.floor((d % 3600) % 60);

        let hDisplay = (h <= 9 ? '0' : '') + h;
        let mDisplay = (m <= 9 ? '0' : '') + m;
        let sDisplay = (s <= 9 ? '0' : '') + s;
        return hDisplay + ':' + mDisplay + ':' + sDisplay;
    }

    /*
    ** ==========================================================
    ** Hours/Minutes Conversion
    ** ==========================================================
    */
    time(d) {
        return d.toLocaleString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        });
    }

    dayafter(d) {
        let day = new Date(d);
        return new Date(day.setDate(day.getDate() + 1));
    }

    daybefore(d) {
        let day = new Date(d);
        return new Date(day.setDate(day.getDate() - 1));
    }

    startenddates(day) {
        let startdate = this.daybefore(new Date(day));
        startdate.setHours(23, 59, 59, 999);
        let enddate = this.dayafter(day);
        enddate.setHours(0, 0, 0, 0);
        return [startdate, enddate];
    }

    formatDate(date) {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd;
        return date;
    }

    backLocation() {
        let location = this.event;
        switch (location) {
            case 'attendance':
                this.router.navigate(['attendance']);
                break;
            case 'project-metrics':
                this.router.navigate(['project-metrics']);
                break;
            default:
                this.router.navigate(['employees-details']);
        }
    }

    formatStartTime(date) {
        var datePipe = new DatePipe('en-US');
        let startDate = datePipe.transform(date, 'MM/dd/yyyy');
        this.startTime = new Date(startDate + ' ' + this.startingTime);
        this.graceStartTime = new Date(new Date(startDate + ' ' + this.startingTime).getTime() + (16 * 60 * 1000));
    }

    open(index: number): void {
        // open lightbox
        this._lightbox.open(this.screenShotImage, index);
    }

    close(): void {
        // close lightbox programmatically
        this._lightbox.close();
    }

    async getCheckInCheckOutInfo(date) {
        this.workHoursInfo = [];
        this.breakHoursInfo = [];
        this.isCheckIn = false;
        this.checkInWorkHours = '00:00:00';
        this.checkInTime = '00:00:00';
        this.checkOutTime = '00:00:00';
        this.checkOutWorkHours = '00:00:00';

        let queryInstance = this.parseService.instance.Object.extend('CheckInCheckout');
        let query = new this.parseService.instance.Query(queryInstance);

        let startend = this.startenddates(new Date(date));
        query.greaterThan('checkInDate', startend[0]);
        query.lessThan('checkInDate', startend[1]);

        query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: this.selectedUserProfileId });
        let checkInCheckoutInfo = await query.find();
        if (checkInCheckoutInfo.length > 0) {
            this.isCheckIn = true;

            this.checkInWorkHours = checkInCheckoutInfo[0].get('totalWorkHours') ? checkInCheckoutInfo[0].get('totalWorkHours') : '00:00:00';
            this.checkOutWorkHours = checkInCheckoutInfo[0].get('totalBreakHours') ? checkInCheckoutInfo[0].get('totalBreakHours') : '00:00:00';
            this.checkInTime = new Date(checkInCheckoutInfo[0].get('inTime'));
            // this.checkOutTime = new Date(checkInCheckoutInfo[0].get('outTime'));

            let inOutInfo = checkInCheckoutInfo[0].get('InOut');

            if (inOutInfo[inOutInfo.length - 1].direction == 'in') {


                let lastOutTime = new Date(inOutInfo[inOutInfo.length - 2].logDate).getTime();
                let convertIstTimeFormat = new Date(lastOutTime);
                convertIstTimeFormat.setHours(convertIstTimeFormat.getHours() - 5);
                convertIstTimeFormat.setMinutes(convertIstTimeFormat.getMinutes() - 30);

                this.checkOutTime = convertIstTimeFormat;
            }
            else if (inOutInfo[inOutInfo.length - 1].direction == 'out') {
                let lastOutTime = new Date(inOutInfo[inOutInfo.length - 1].logDate).getTime();
                let convertIstTimeFormat = new Date(lastOutTime);
                convertIstTimeFormat.setHours(convertIstTimeFormat.getHours() - 5);
                convertIstTimeFormat.setMinutes(convertIstTimeFormat.getMinutes() - 30);
                this.checkOutTime = convertIstTimeFormat;
            }

            this.workHoursInfo = [];
            this.breakHoursInfo = [];

            var i = 0;
            var j = 0;

            for (let data of checkInCheckoutInfo[0].get('InOut')) {

                var outTime = new Date(data.logDate).getTime();
                var convertIstTimeFormat = new Date(outTime);
                convertIstTimeFormat.setHours(convertIstTimeFormat.getHours() - 5);
                convertIstTimeFormat.setMinutes(convertIstTimeFormat.getMinutes() - 30);

                if (data.direction == 'in') {
                    var checkInCheckoutDetails: any = {
                        inTime: convertIstTimeFormat,
                        inDirection: data.direction
                    }
                }
                else if (data.direction == 'out') {
                    i = i + 1;
                    checkInCheckoutDetails.outDirection = data.direction;
                    checkInCheckoutDetails.outTime = convertIstTimeFormat;
                    checkInCheckoutDetails.position = i;

                    let reamingHours = this.remainingHours(checkInCheckoutDetails.inTime, checkInCheckoutDetails.outTime);
                    checkInCheckoutDetails.totalWorkHour = reamingHours;
                    this.workHoursInfo.push(checkInCheckoutDetails);
                    checkInCheckoutDetails = {};
                }

                if (data.direction == 'in' && checkInCheckoutInfo[0].get('InOut')[0] != data) {
                    j = j + 1;
                    checkInCheckoutBreak.inDirection = data.direction;
                    checkInCheckoutBreak.inTime = convertIstTimeFormat;
                    checkInCheckoutBreak.position = j;

                    let breakHours = this.remainingHours(checkInCheckoutBreak.outTime, checkInCheckoutBreak.inTime);
                    checkInCheckoutBreak.totalBreakHour = breakHours;
                    this.breakHoursInfo.push(checkInCheckoutBreak);
                    checkInCheckoutBreak = {};
                }
                else if (data.direction == 'out' && checkInCheckoutInfo[0].get('InOut')[checkInCheckoutInfo[0].get('InOut').length - 1] != data) {
                    var checkInCheckoutBreak: any = {
                        outTime: convertIstTimeFormat,
                        outDirection: data.direction
                    }
                }
            }

        }
    }

    remainingHours(checkIn, checkOut) {
        let remainHours = checkOut - checkIn;
        let hour: any = Math.abs(Math.floor((remainHours % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
        let minutes: any = Math.abs(Math.floor((remainHours % (1000 * 60 * 60)) / (1000 * 60)));
        if (minutes < 10) { minutes = '0' + minutes; }
        if (hour < 10) { hour = '0' + hour; }
        return `${hour}:${minutes}`;
    }
}

let workData: WorkElement[] = [];
let breakData: BreakElement[] = [];

export interface SelectItem {
    label?: string;
    value: any;
    styleClass?: string;
    icon?: string;
    title?: string;
    disabled?: boolean;
}
